module.exports = __webpack_public_path__ + "static/all-loans-page-a9a472338100a39753f47eadbe6589be.png";